import dayjs from 'dayjs'
import { setSelected, parseDay, getFirstDay, getLastDay, getNextDay, yearMonthDay, getFirstAvailableDay } from './utls'

const defaultToday = dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0)
const defautFirstDay = dayjs()
const lastAvailableDate = dayjs()

const blockedDay = (day, firstDay, lastDay, datesArray) => {
  const beforeFirstDay = firstDay ? dayjs(day).isBefore(firstDay) : false
  const isDateAbsent = datesArray && datesArray.length > 0 ? !datesArray.some((element) => dayjs(element).diff(day, 'days') === 0) : true
  return defaultToday > day || beforeFirstDay || dayjs(day).isAfter(lastDay) || isDateAbsent
}

const initialState = {
  availableDates: [],
  today: defaultToday,
  firstAvailableDate: defautFirstDay,
  lastAvailableDate: lastAvailableDate,
  date: yearMonthDay(defautFirstDay),
  selected: [yearMonthDay(defautFirstDay)],
  focusedDayNum: dayjs(defautFirstDay).format('D'),
  updateMessage: '',
  isBlockedDay: blockedDay,
}

const CalendarReducer = (state = initialState, action) => {
  let newState = {}
  switch (action.type) {
    case 'CALENDAR_UPDATE_WITH_API':

      {
        let firstAvailableDate = dayjs(action.payload.firstAvailableDate)
        let lastAvailableDate = dayjs(action.payload.lastAvailableDate)
        newState = {
          ...state,
          availableDates: action.payload.availableDates,
          firstAvailableDate: firstAvailableDate,
          lastAvailableDate: lastAvailableDate,
          date: yearMonthDay(firstAvailableDate),
          selected: [yearMonthDay(firstAvailableDate)],
          focusedDayNum: dayjs(firstAvailableDate).format('D'),
        }
      }

      break
    case 'CALENDAR_UPDATES':
      newState = { ...state, updateMessage: action.payload }

      break
    case 'SELECT_DATE':
      if (state.isBlockedDay(dayjs(action.payload, state.firstAvailableDate, state.lastAvailableDate, state.availableDates))) {
        newState = {
          ...state,
          selected: setSelected(state.selected, action.payload),
          focusedDayNum: parseDay(action.payload),
        }
      } else {
        newState = { ...state }
      }
      break
    case 'SELECT_NEXT':
      const nextNewDate = yearMonthDay(dayjs(state.date).add(1, 'month'))
      newState = {
        ...state,
        date: nextNewDate,
        focusedDayNum: getFirstAvailableDay(nextNewDate, state),
      }
      break
    case 'SELECT_PREVIOUS':
      const previousNewDate = yearMonthDay(dayjs(state.date).subtract(1, 'month'))
      newState = {
        ...state,
        date: previousNewDate,
        focusedDayNum: getFirstAvailableDay(previousNewDate, state),
      }
      break
    case 'FOCUS_DAY':
      newState = {
        ...state,
        focusedDayNum: action.payload.focused,
      }
      break
    case 'KEY_UP':
      newState = {
        ...state,
        ...getNextDay(Number(state.focusedDayNum) - 7, state, 'up'),
      }
      break
    case 'KEY_DOWN':
      newState = {
        ...state,
        ...getNextDay(Number(state.focusedDayNum) + 7, state, 'down'),
      }
      break
    case 'KEY_RIGHT':
      newState = {
        ...state,
        ...getNextDay(Number(state.focusedDayNum) + 1, state, 'right'),
      }
      break
    case 'KEY_LEFT':
      newState = {
        ...state,
        ...getNextDay(Number(state.focusedDayNum) - 1, state, 'left'),
      }
      break
    default:
      newState = { ...state }
  }
  newState.firstDay = getFirstDay(newState.date)
  newState.lastDay = getLastDay(newState.date)
  return newState
}

export default CalendarReducer
